module.exports = __webpack_public_path__ + "media/src/images/clouds-65a832fe3ec8c92da67289ec871a55a1.png";